import { LOT_TYPE_ENUM, LotTypeEnumId } from '@classictechsolutions/hubapi-transpiled-enums';

interface IMigratingHeaderOptions {
    prefix: string;
    lotType: LotTypeEnumId;
    numberOfLots: number;
    unitsPerBlock?: number;
}

export function buildMigratingHeader(options: IMigratingHeaderOptions): string {
    const { prefix, lotType, numberOfLots, unitsPerBlock } = options;
    const multipleLots = numberOfLots > 1;

    if (lotType === LotTypeEnumId.Standalone) {
        return `${prefix}  (${numberOfLots}) ${LOT_TYPE_ENUM[lotType]} lot${multipleLots ? 's' : ''}`;
    }

    if (lotType === LotTypeEnumId.TerracedBlock) {
        const base = `${prefix}  (${numberOfLots}) ${LOT_TYPE_ENUM[lotType]}${multipleLots ? 's' : ''}`;
        if (unitsPerBlock === undefined) {
            return base;
        }

        const multipleUnits = unitsPerBlock > 1;
        return `${base} and (${unitsPerBlock}) Unit${multipleUnits ? 's' : ''} per Block`;
    }

    return '';
}
